import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDistanceToNowStrict } from 'date-fns';
import { ZendeskArticle } from 'interfaces/ZendeskArticle';
import { Typography } from '@mui/material';

import { useLocale } from 'hooks/useLocale';

const ArticleMetaData = ({ article }: { article?: ZendeskArticle }) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const [lastUpdated, setLastUpdated] = useState<Date | undefined>();

  useEffect(() => {
    if (article) {
      const updated = new Date(article.updated_at);
      setLastUpdated(updated);
    }
  }, [article]);

  return (
    <ul className="mt-1 mb-0">
      <Typography component="li" variant="caption">
        <time dateTime={article?.updated_at} title={article?.updated_at} data-datetime="relative">
          {lastUpdated ? formatDistanceToNowStrict(lastUpdated, { addSuffix: true, locale }) : ''}
        </time>
        <span className="mx-1">&middot;</span>
        <span>{t('article.updated')}</span>
      </Typography>
    </ul>
  );
};

export default ArticleMetaData;
